/* @ngInject */
function WarningCaptionController ($scope) {
  const api = {}
  this.getApi = () => api

  activate()

  function activate () {}
}

export { WarningCaptionController }
